<template>
  <b-card id="page-membership" no-body class="mb-0 p-2">
    <b-card no-body class="card-apply-job">
      <b-card-header class="pb-1 d-md-table membership-header d-block">
        <b-row class="align-items-center">
          <!-- Columna del avatar -->
          <b-col cols="12" md="3" class="text-center mb-3 mb-md-0">
            <b-avatar
              v-if="subscription.idSubscription != null"
              :variant="tagsColorSubscription(subscription.idSubscription)"
              size="150"
              class="avatar-shadow"
              :src="tagsUrlSubscription(subscription.idSubscription)"
            />
          </b-col>

          <!-- Columna de información -->
          <b-col cols="12" md="9">
            <div class="membership-info">
              <h2 class="mb-3 text-primary text-center text-md-left">
                {{ $t("my-membership") }}
              </h2>

              <div v-if="subscription.active" class="dates-container mb-4">
                <div class="date-item">
                  <span class="date-label"
                    >{{ $t(labelHeader("start_date")) }}:</span
                  >
                  <span class="date-value">{{
                    formatDate(subscription.startDate)
                  }}</span>
                </div>
                <div class="date-item">
                  <span class="date-label"
                    >{{ $t(labelHeader("endd_date")) }}:</span
                  >
                  <span class="date-value">{{
                    formatDate(subscription.endDate)
                  }}</span>
                </div>
                <div class="subscription-type">
                  <span class="type-label">Tipo de suscripción:</span>
                  <b-badge variant="light-info" pill>{{
                    subscription.nameSubscription
                  }}</b-badge>
                </div>
              </div>
              <div v-if="!subscription.active" class="dates-container mb-4">
                <div class="date-item">
                  <span class="date-label">Validación de pago</span>
                </div>
              </div>

              <b-badge
                v-if="subscription.active"
                pill
                :variant="tagsColor(isEndDateBeforeToday(subscription.endDate))"
                class="status-badge"
              >
                <span class="badge-text">
                  {{
                    isStartDateAfterToday(subscription.startDate)
                      ? "Validación de pago"
                      : membershipStatus()
                  }}
                </span>
              </b-badge>
            </div>
          </b-col>
        </b-row>
      </b-card-header>

      <b-card-body class="membership-body">
        <b-card-text class="description mb-4">
          {{ subscription.subscription.description }}
        </b-card-text>

        <div class="price-container bg-light-primary p-3 rounded-lg mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <div class="price-display">
              <sup class="currency-symbol">$</sup>
              <h2 class="price-amount d-inline-block mx-2">
                {{ subscription.subscription.price }}
              </h2>
              <span class="price-period"
                >/{{ subscription.subscription.nameType }}</span
              >
            </div>
            <b-badge variant="light-primary" pill class="currency-badge">
              {{ subscription.subscription.nameCoinType }}
            </b-badge>
          </div>
        </div>

        <div class="action-buttons">
          <b-button
            variant="primary"
            block
            class="mb-3 button-main"
            @click="modal_change_membership()"
          >
            {{ $t(labelHeader("change_membership")) }}
          </b-button>

          <b-button
            variant="outline-primary"
            block
            class="button-secondary"
            @click="modal_pay_membership()"
          >
            {{ $t(labelHeader("pay")) }}
          </b-button>
        </div>
      </b-card-body>
    </b-card>

    <b-modal
      v-model="modal_membership"
      centered
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <template #modal-title>
        {{
          changes_memmbership
            ? $t(labelHeader("change_membership"))
            : $t(labelHeader("pay"))
        }}
      </template>

      <b-card-text style="margin-bottom: -1.5rem !important">
        <b-row class="d-flex justify-content-between align-items-start">
          <b-col cols="12" sm="12" md="12" lg="6" xl="6">
            <b-card
              class="card-transaction"
              no-body
              style="height: 400px !important; width: 100%"
            >
              <b-card-header>
                <b-card-title>{{
                  $t(labelHeader("name_subscription"))
                }}</b-card-title>
              </b-card-header>

              <b-card-body>
                <validation-observer ref="form_select_memberships">
                  <b-row
                    style="
                      margin-top: -1rem !important;
                      margin-bottom: 0.5rem !important;
                    "
                  >
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t(labelHeader('name_subscription'))"
                        rules="required"
                      >
                        <b-form-group :state="errors.length > 0 ? false : null">
                          <v-select
                            v-model="subscripcion"
                            input-id="name_subscription"
                            :options="allSubcriptions"
                            label="name"
                            :placeholder="$t(labelHeader('name_subscription'))"
                            @input="chargeSubcription"
                            :disabled="subscripcionSelect"
                          >
                          </v-select>
                          <b-form-invalid-feedback
                            :state="errors.length > 0 ? false : null"
                          >
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </validation-observer>
                <div class="transaction-item">
                  <b-media no-body class="item">
                    <b-media-aside>
                      <b-avatar rounded size="30" variant="success">
                        <feather-icon size="18" icon="StarIcon" />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="transaction-title">
                        {{
                          subscriptionData != null
                            ? subscriptionData.nameType
                            : ""
                        }}
                      </h6>
                    </b-media-body>
                  </b-media>
                  <b-media no-body class="item">
                    <b-media-aside>
                      <b-avatar rounded size="30" variant="success">
                        <feather-icon size="18" icon="DollarSignIcon" />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="transaction-title">
                        {{
                          subscriptionData != null ? subscriptionData.price : ""
                        }}
                        {{
                          subscriptionData != null
                            ? subscriptionData.nameCoinType
                            : ""
                        }}
                      </h6>
                    </b-media-body>
                  </b-media>
                  <b-media no-body class="item">
                    <b-media-aside>
                      <b-avatar rounded size="30" variant="success">
                        <feather-icon size="18" icon="BookOpenIcon" />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="transaction-title">
                        {{
                          subscriptionData != null
                            ? subscriptionData.description
                            : ""
                        }}
                      </h6>
                    </b-media-body>
                  </b-media>
                </div>
              </b-card-body>

              <div class="text-center mb-1">
                <b-button
                  style="width: 60% !important"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="selectSubcription"
                  :disabled="subscripcionSelect"
                >
                  {{ $t(labelHeader("select_membership")) }}
                </b-button>
              </div>
            </b-card>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="6" xl="6">
            <b-card
              class="card-transaction"
              no-body
              style="height: 400px !important ; width: 100%"
            >
              <b-card-header>
                <b-card-title>{{ $t(labelHeader("pay")) }}</b-card-title>
              </b-card-header>

              <b-card-body>
                <validation-observer ref="form_pay_memberships">
                  <b-row
                    class="d-flex justify-content-between align-items-center"
                  >
                    <b-col cols="12">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t(labelHeader('pay_methodes'))"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t(labelHeader('pay_methodes'))"
                          label-for="pay_methodes"
                          :state="errors.length > 0 ? false : null"
                        >
                          <v-select
                            v-model="pay_methodes"
                            input-id="pay_methodes"
                            :options="allPayMethodes"
                            label="name"
                            :placeholder="$t(labelHeader('pay_methodes'))"
                            @input="chargeaPayMethode"
                            :disabled="paySelect || !subscripcionSelect"
                          >
                          </v-select>

                          <b-form-invalid-feedback
                            :state="errors.length > 0 ? false : null"
                          >
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col cols="6">
                      <b-form-group
                        :label="$t(labelHeader('referencePay'))"
                        label-for="referencePay"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :name="$t(labelHeader('referencePay'))"
                          rules="required"
                        >
                          <b-form-input
                            id="referencePay"
                            v-model="referencePay"
                            :state="errors.length > 0 ? false : null"
                            :placeholder="$t(labelHeader('referencePay'))"
                            :disabled="!subscripcionSelect"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t(labelHeader('amounth'))"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t(labelHeader('amounth'))"
                          label-for="amounth"
                          :state="errors.length > 0 ? false : null"
                        >
                          <b-input-group prepend="$">
                            <cleave
                              id="amounth"
                              v-model="amounth"
                              :raw="false"
                              class="form-control"
                              :options="options.number"
                              :placeholder="$t(labelHeader('amounth'))"
                              :disabled="!subscripcionSelect"
                            />
                          </b-input-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        :label="$t(labelHeader('voucher'))"
                        label-for="voucher"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :name="$t(labelHeader('voucher'))"
                          rules="required"
                        >
                          <b-form-file
                            id="voucher"
                            :placeholder="$t(labelHeader('voucher'))"
                            v-model="voucher"
                            browse-text="adjuntar"
                            :state="errors.length > 0 ? false : null"
                            :disabled="!subscripcionSelect"
                            @input="uploadVoucher"
                          >
                          </b-form-file>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </validation-observer>
              </b-card-body>

              <div class="text-center mb-1">
                <b-button
                  style="width: 40% !important"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="paySubcription"
                >
                  Pagar
                </b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardText,
  BCardBody,
  BFormInvalidFeedback,
  BFormFile,
  BInputGroup,
  BCardGroup,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import { getParams, decimalNumberFormat } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";

import {
  allCompanyMemberships,
  editMembership,
  allMembershipsOfcompany,
  registerPaymentSubcription,
} from "@core/api/request/membership";
import { allSubcriptions } from "@core/api/request";

import { required } from "@validations";

import { getCatalog, postFile } from "@core/api/request/catalogs";

import Cleave from "vue-cleave-component";
import * as moment from "moment";
import "moment/locale/es";
import "moment-timezone";

const subscriptionTemplate = {
  active: 0,
  company: {},
  guidCompany: null,
  endDate: null,
  guidSubscription: null,
  idCompany: null,
  idSubscription: null,
  idSubscriptionCompany: null,
  nameCompany: null,
  nameSubscription: null,
  startDate: null,
  subscription: {},
};

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    vSelect,
    Filterss,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BCardText,
    BCardBody,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    Cleave,
    BFormFile,
    BInputGroup,
    BCardGroup,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    loading: false,
    required,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    items: [],
    companyGuid: null,
    subscription: Object.assign(subscriptionTemplate),
    active: null,
    guidSubscription: null,
    membershipData: null,
    changes_memmbership: false,
    pay_membership: false,
    modal_membership: false,
    allSubcriptions: [],
    subscripcion: null,
    id_subscripcion_membership: null,
    subscriptionData: null,
    subscripcionSelect: false,
    payAviable: false,
    allPayMethodes: [],
    pay_methodes: null,
    paySelect: false,
    amounth: null,
    options: {
      number: {
        // numeralDecimalMark: '.',
        // delimiter: ',',
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        numeralDecimalScale: 3,
        numeralPositiveOnly: true,
      },
    },
    voucher: null,
    referencePay: null,
    urlVoucher: null,
    name: null,
    filtersOn: false,
    hasNextPage: true,
  }),

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.loadMemberships(guid);
    },
  },
  computed: {},
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
  },
  async mounted() {
    localize("es");
    moment.locale("es");
    await this.loadMemberships();
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadMemberships() {
      this.loading = !this.loading;
      await allMembershipsOfcompany(this.companyGuid)
        .then((resp) => {
          const data = _.get(resp, "data");
          Object.assign(this.subscription, {
            active: data.active || 0,
            company: data.company || {},
            guidCompany: data.guidCompany || null,
            endDate: data.endDate || null,
            guidSubscription: data.guidSubscription || null,
            idCompany: data.idCompany || null,
            idSubscription: data.idSubscription || null,
            idSubscriptionCompany: data.idSubscriptionCompany || null,
            nameCompany: data.nameCompany || null,
            nameSubscription: data.nameSubscription || null,
            startDate: data.startDate || null,
            subscription: data.subscription || {},
          });
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadMembershipsInfinity();
      }
    },
    label(field) {
      return `pages.membership.table.${field}`;
    },

    labelHeader(field) {
      return `pages.membership.table.tableHeader.${field}`;
    },
    tagsColor(status) {
      return status ? "light-success" : "light-danger";
    },
    tagsColorSubscription(idSubscription) {
      switch (idSubscription) {
        case 4:
          return "light-danger";
        case 26:
          return "light-success";
        case 27:
          return "light-danger";
        case 28:
          return "light-danger";
      }
    },

    tagsUrlSubscription(idSubscription) {
      switch (idSubscription) {
        case 4:
          return require("@/assets/images/Prueba.png");
        case 26:
          return require("@/assets/images/Basico.png");
        case 27:
          return require("@/assets/images/Avanzado.png");
        case 28:
          return require("@/assets/images/Corporativo.png");
      }
    },

    formatDate(date) {
      const today = moment().tz("America/Caracas"); // Fecha y hora actual en Caracas
      const inputDate = moment.utc(date).tz("America/Caracas"); // Fecha a evaluar en Caracas
      return inputDate.format("DD/MM/YYYY");
    },
    isEndDateBeforeToday(endDateString) {
      const endDate = new Date(endDateString);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      endDate.setHours(0, 0, 0, 0);

      return today < endDate;
    },

    isStartDateAfterToday(startDateString) {
      if (!startDateString) return false;
      const startDate = new Date(startDateString);
      if (isNaN(startDate)) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      startDate.setHours(0, 0, 0, 0);

      return startDate > today;
    },

    membershipStatus() {
      const today = new Date();
      const endDate = new Date(this.subscription.endDate);

      if (endDate < today) {
        const daysOverdue = Math.round(
          (today - endDate) / (1000 * 60 * 60 * 24),
        );
        return `Vencida hace ${daysOverdue} días`;
      } else {
        const daysRemaining = Math.round(
          (endDate - today) / (1000 * 60 * 60 * 24),
        );
        return `Vigente por ${daysRemaining} días`;
      }
    },

    chargeParamsByAdmin() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);
      if (this.active) arrParams.push(`active,${this.active}`);

      if (
        this.companyGuid != null &&
        this.companyGuid.trim() !== "" &&
        this.companyGuid != "null"
      ) {
        arrParams.push(`guidCompany,${this.companyGuid}`);
      }

      if (this.guidSubscription != null)
        arrParams.push(`guidSubscription,${this.guidSubscription}`);

      return getParams(arrParams);
    },
    async modal_change_membership() {
      this.changes_memmbership = true;
      this.pay_membership = false;
      this.subscripcionSelect = false;
      this.id_subscripcion_membership = this.subscription.idSubscription;
      await this.loadSubscriptions();
      await this.loadPayMethodes();
      this.modal_membership = true;
    },
    chargeSubcription(value) {
      this.subscriptionData = value;
    },
    async modal_pay_membership() {
      await this.loadPayMethodes();
      this.subscripcion = {
        idSubscription: this.subscription.idSubscription,
        value: this.subscription.idSubscription,
        name: this.subscription.nameSubscription,
        guid: this.subscription.guidSubscription,
      };

      await this.loadSubscriptions();

      this.subscriptionData = this.subscription.subscription;
      this.changes_memmbership = false;
      this.pay_membership = true;
      this.subscripcionSelect = true;
      this.modal_membership = true;
    },
    selectSubcription() {
      this.$refs.form_select_memberships.validate().then((success) => {
        if (success) {
          this.subscripcionSelect = true;
          this.payAviable = true;
        } else {
          this.alertToast(
            "danger",
            "Alerta error",
            "Debe seleccionar una suscripción",
          );
        }
      });
    },
    async updateSubcription(data, guidSubscription) {
      let status = false;
      let subscripcion = {
        idSubscriptionCompany: data.idSubscriptionCompany,
        guidCompany: data.guidCompany,
        guidSubscription: guidSubscription,
      };

      await editMembership(subscripcion)
        .then((resp) => {
          if (!resp.err) {
            status = true;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      return status;
    },

    async uploadVoucher() {
      if (this.voucher != null) {
        let result = await postFile(this.voucher);

        if (result.data != null) {
          this.urlVoucher = result.data;
        } else {
          this.alertToast(
            "danger",
            "Alerta error",
            "Hubo un error al subir el archivo",
          );
          this.voucher = null;
        }
      }
    },
    async createPaymenth() {
      let status = false;
      let payment = {
        idSubscriptionCompany: this.subscription.idSubscriptionCompany,
        date: new Date().toISOString(),
        amount: decimalNumberFormat(this.amounth),
        idCatPaymentType: this.pay_methodes.id,
        urlProofOfPayment: this.urlVoucher,
        referenceNumber: this.referencePay,
      };
      await registerPaymentSubcription(payment)
        .then((resp) => {
          if (!resp.err) {
            status = true;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      return status;
    },
    async paySubcription() {
      try {
        const isValid = await this.$refs.form_pay_memberships.validate();
        if (!isValid) {
          this.alertToast(
            "danger",
            "Error",
            "Complete todos los campos requeridos",
          );
          return;
        }

        // Validar montos
        if (parseFloat(this.amounth) <= 0) {
          this.alertToast("danger", "Error", "Monto inválido");
          return;
        }

        // Subir comprobante primero
        if (!this.urlVoucher) {
          await this.uploadVoucher();
          if (!this.urlVoucher) {
            this.alertToast("danger", "Error", "Debe subir un comprobante");
            return;
          }
        }

        let success = false;

        if (this.pay_membership) {
          success = await this.createPaymenth();
        } else if (this.changes_memmbership) {
          const updateSuccess = await this.updateSubcription(
            this.subscription,
            this.subscripcion.guid,
          );
          if (updateSuccess) {
            success = await this.createPaymenth();
          }
        }

        if (success) {
          this.alertToast(
            "success",
            "Éxito",
            "Operación completada correctamente",
          );
          this.resetModal();
          await this.loadMemberships();
        }
      } catch (error) {
        console.error("Error en el proceso de pago:", error);
        this.alertToast(
          "danger",
          "Error",
          "Ocurrió un error al procesar el pago",
        );
      }
      // if (await this.$refs.form_pay_memberships.validate()) {
      //   if (this.pay_membership) {
      //     const resultPay = await this.createPaymenth();
      //     if (resultPay) {
      //       this.alertToast("success", `Exito`, "Registro de pago exitoso");
      //       this.modal_membership = false;
      //       await this.loadMemberships();
      //     }
      //   } else if (this.changes_memmbership) {
      //     const resultUpdate = await this.updateSubcription(
      //       this.subscription,
      //       this.subscripcion.guid
      //     );

      //     if (resultUpdate) {
      //       const resultPay = await this.createPaymenth();
      //       if (resultPay) {
      //         this.alertToast(
      //           "success",
      //           `Exito`,
      //           "Cambio de suscripción y registro de pago exitoso"
      //         );
      //         this.modal_membership = false;
      //         await this.loadMemberships();
      //       }
      //     } else {
      //       this.alertToast("danger", "Alerta error", "Hubo un error");
      //     }
      //   }
      // } else {
      //   this.alertToast(
      //     "danger",
      //     "Alerta error",
      //     "Debe llenar todos los campos"
      //   );
      // }
    },
    resetModal() {
      this.modal_membership = false;
      this.subscripcionSelect = false;
      this.payAviable = false;
      this.voucher = null;
      this.amounth = null;
      this.referencePay = null;
      this.$refs.form_pay_memberships.reset();
    },
    chargeaPayMethode() {},
    async loadMembershipsInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const param = this.chargeParamsByAdmin();
        await allCompanyMemberships(param)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            this.hasNextPage = data?.currentPage < data?.totalPages || 0;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.log("error", error.message);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      }
    },
    async loadPayMethodes() {
      let arrParams = [];
      arrParams.push(`itemsPage,${1}`);

      arrParams.push(`itemsRows,${44}`);
      arrParams.push("guidCatalog, 97ba7fc1-0312-4a6f-a5eb-12a4cfe6c592");
      await getCatalog(getParams(arrParams))
        .then((resp) => {
          const data = _.get(resp, "data");

          this.allPayMethodes = data?.listOfItems.items || [];
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    chargeParamsSub() {
      const arrParams = [];

      arrParams.push(`page,${1}`);

      arrParams.push(`rows,${50}`);

      return getParams(arrParams);
    },
    async loadSubscriptions() {
      const param = this.chargeParamsSub();

      await allSubcriptions(param)
        .then((resp) => {
          const data = _.get(resp, "data");

          this.allSubcriptions =
            data?.items.filter(
              (item) =>
                item.idSubscription !== 4 &&
                item.idSubscription !== this.subscription.idSubscription,
            ) || [];
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    handlePerPageChange() {
      this.loadMemberships();
    },
    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadMemberships();
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style scoped>
.membership-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

.avatar-shadow {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.membership-info h2 {
  font-weight: 600;
  letter-spacing: -0.5px;
}

.dates-container {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.date-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
}

.date-label {
  font-weight: 500;
  color: #6c757d;
  min-width: 140px;
}

.date-value {
  color: #495057;
  font-weight: 600;
}

.subscription-type {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}

.status-badge {
  padding: 0.8rem 1.5rem;
  font-size: 1.1rem;
  transition: transform 0.2s;
}

.status-badge:hover {
  transform: translateY(-2px);
}

.description {
  color: #4a5568;
  line-height: 1.7;
  font-size: 1.1rem;
}

.price-container {
  border: 1px solid #dee2e6;
}

.price-display {
  display: flex;
  align-items: baseline;
}

.currency-symbol {
  font-size: 1.2rem;
  top: -0.5em;
}

.price-amount {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
}

.price-period {
  color: #718096;
  font-size: 1.1rem;
}

.button-main {
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.button-secondary {
  padding: 0.8rem;
  border-width: 2px;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .date-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .date-label {
    margin-bottom: 0.3rem;
  }

  .avatar-shadow {
    size: 120px;
  }
}
</style>
